module.exports = __webpack_public_path__ + "static/media/test8_2.4b595872.png";